module.exports = __webpack_public_path__ + "static/Patrick Duncan.27d2f2ab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mentors/Patrick Duncan.jpg
// module id = 1228
// module chunks = 6166952557895